import React from "react";
import { createPortal } from "react-dom";
import useSidePanel from "../../useSidePanel";
import "./Drawer.css";

/** Боковая панель признания: открывается под шапкой портала; themeClass задаёт акцентный цвет */
function Drawer({ isOpen, onClose, caption, title, subtitle, children, footer, themeClass }) {
  const headerOffset = useSidePanel(isOpen, onClose);
  if (!isOpen) return null;

  return createPortal(
    <div
      className={`rr-drawer-overlay ${themeClass || ""}`}
      style={{ top: headerOffset }}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <aside className="rr-drawer" role="dialog" aria-modal="true" aria-label={title}>
        <header className="rr-drawer__header">
          <div className="rr-drawer__heading">
            {caption && <div className="rr-drawer__caption">{caption}</div>}
            <h2 className="rr-drawer__title">{title}</h2>
            {subtitle && <div className="rr-drawer__subtitle">{subtitle}</div>}
          </div>
          <button type="button" className="rr-drawer__close" aria-label="Закрыть" onClick={onClose}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M1.5 1.5L12.5 12.5M12.5 1.5L1.5 12.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </header>
        <div className="rr-drawer__body">{children}</div>
        {footer && <footer className="rr-drawer__footer">{footer}</footer>}
      </aside>
    </div>,
    document.body
  );
}

export default Drawer;
